export interface Policy {
  slug: string;
  title: string;
  lastUpdated: Date;
  description?: string;
}

export const policies: Policy[] = [
  {
    slug: "code-of-conduct",
    title: "Code of Conduct",
    lastUpdated: new Date("2026-02-20"),
    description: "Expected behaviour and standards for all participants",
  },
  {
    slug: "photo-consent",
    title: "Photo Consent Policy",
    lastUpdated: new Date("2026-02-20"),
    description: "How we use photographs and your rights regarding photography",
  },
  {
    slug: "booking-policy",
    title: "Booking Policy",
    lastUpdated: new Date("2026-02-20"),
    description: "Terms and conditions for event bookings",
  },
  {
    slug: "data-processing",
    title: "Data Processing Policy",
    lastUpdated: new Date("2026-02-20"),
    description: "How we collect, use, and protect your personal information",
  },
  {
    slug: "powerboat-tractor-policy",
    title: "Powerboat and Tractor Usage Policy",
    lastUpdated: new Date("2026-07-12"),
    description:
      "Requirements for operating club powerboats and the club tractor",
  },
];

export function getPolicyBySlug(slug: string): Policy | undefined {
  return policies.find((policy) => policy.slug === slug);
}

// Import markdown content as text
import codeOfConductContent from "./code-of-conduct.md?raw";
import photoConsentContent from "./photo-consent.md?raw";
import bookingPolicyContent from "./booking-policy.md?raw";
import dataProcessingContent from "./data-processing.md?raw";
import powerboatTractorPolicyContent from "./powerboat-tractor-policy.md?raw";

export function getPolicyContent(slug: string): string {
  switch (slug) {
    case "code-of-conduct":
      return codeOfConductContent;
    case "photo-consent":
      return photoConsentContent;
    case "booking-policy":
      return bookingPolicyContent;
    case "data-processing":
      return dataProcessingContent;
    case "powerboat-tractor-policy":
      return powerboatTractorPolicyContent;
    default:
      return "";
  }
}
